import { ASSEMBLER } from '@hive/status'
import { GQL_ID, NestedFilter } from '@@partner:types:graphql'
import React, { useCallback } from 'react'
import { prepareAssemblerFilter } from '@@partner:helpers/assembler'

import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { ShopsPicker } from '@components/common/pickers'

export type AssemblersFiltersType = {
  id?: GQL_ID
  name?: string
  phone?: string
  status?: number[]
  shopIds: GQL_ID[]
}

type AssemblersFilterProps = {
  onFilterChanged: (filters: NestedFilter) => void
}

const defaultFilter: AssemblersFiltersType = {
  id: undefined,
  name: undefined,
  phone: undefined,
  status: undefined,
  shopIds: []
}

const searchableAssemblerStatuses = [
  { label: 'Активен', value: ASSEMBLER.ACTIVE },
  { label: 'Неактивен', value: ASSEMBLER.INACTIVE },
  { label: 'Заблокирован', value: ASSEMBLER.BLOCKED }
]

const filterConfig = [
  createFilter.text('id', 'ID'),
  createFilter.text('name', 'ФИО'),
  createFilter.text('phone', 'Номер телефона'),
  createFilter.multiselect('status', searchableAssemblerStatuses, 'Статус', {
    searchable: false
  }),
  createFilter.custom('shopIds', 'Магазины', ({ value, onChange }) => (
    <ShopsPicker multiple value={value} onChange={onChange} />
  ), { valueType: 'string[]' })
]

export default function AssemblersFilter ({
  onFilterChanged
}: AssemblersFilterProps) {
  const handleSubmit = useCallback((state: AssemblersFiltersType) => {
    onFilterChanged(prepareAssemblerFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSubmit}
    />
  )
}